import { useDispatch, useSelector } from 'react-redux';
import SelectRole from './Components/SelectRole';
import OnboardingContainer from './OnboardingContainer'
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom'

const SelectManufacturerRole = () => {
  const navigate = useNavigate();
  const manufacturerRoleFlow = useSelector(state => state.FirmOnboardingReducer.manufacturerRoleFlow);
  const dispatch = useDispatch();
  const {
    existingFirm
  } = useSelector(state => state.FirmOnboardingReducer || {});
    
  const handleRoleContinue = useCallback(({ isAnyRoleGstRequired, hasGST }) => {
    if (manufacturerRoleFlow) {
      if (isAnyRoleGstRequired && !hasGST) {
        dispatch({ type: 'SET_GST_FLOW', payload: true });
        navigate('/firm-onboarding/onboard-firm');
      } else {
        navigate('/firm-onboarding/confirm-details');
      }
      return;
    }
    if(existingFirm && hasGST) {
        navigate('/firm-onboarding/confirm-details');
        return;
    }
    if (isAnyRoleGstRequired && !hasGST) {
      dispatch({ type: 'SET_GST_FLOW', payload: true });
    }
    navigate('/firm-onboarding/onboard-firm');
  }, [dispatch, manufacturerRoleFlow, navigate]);

  return (
    <OnboardingContainer title="Business Info"
      buttonHandler={() => navigate('/firm-onboarding/onboard-firm')}
    > 
      <SelectRole 
        ButtonTop={false}
        onContinue={handleRoleContinue}
      />
    </OnboardingContainer>
  )
}

export default SelectManufacturerRole
